import React, { Component } from 'react'
import { connect } from 'react-redux';
import { withTranslation} from 'react-i18next';
import DetailOrder from '../../orders/detailOrder';
import { getOnlineOrderToMerge, getOnlineQuotationToMerge} from '../../../actions'
import { Spin } from 'antd';

class CatalogOrderQuotationMergeDetail extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {

    // Check if order or quotation
    if (this.props.isQuotation) {

      // Quotation
      const quotationId = this.props.order.id
      this.props.getOnlineQuotationToMerge(quotationId)

    } else {

      // Order
      const orderId = this.props.order.id
      this.props.getOnlineOrderToMerge(orderId)
    }
  }

  render() {

    const { t, isQuotation, order, onlineOrdersToMerge, onlineQuotationsToMerge} = this.props

    let onlineOrder

    // Check if order or quotation
    if (this.props.isQuotation) {
      onlineOrder = onlineQuotationsToMerge[order.id]
    } else {
      onlineOrder = onlineOrdersToMerge[order.id]
    }

    return (
      <div style={{width: '100%'}}>

        {onlineOrder
          ?

          <div style={{ display: 'flex' }}>
            <div style={{borderRight: '1px solid', borderColor: '#d1d1d1', padding: '0px 10px'}}>
              <h4 style={{textAlign: 'center'}}>{ t('Offline ' + ((isQuotation) ? 'quotation' : 'order')) }</h4>
              <DetailOrder
                {...this.props}
                order={order}
                infoClient={order.cliente}
                isQuotation={isQuotation}
              />
            </div>
            <div style={{ padding: '0px 10px' }}>
              <h4 style={{textAlign: 'center'}}>{ t('Online ' + ((isQuotation) ? 'quotation' : 'order')) }</h4>

              {onlineOrder &&
                <DetailOrder
                  {...this.props}
                  order={onlineOrder}
                  infoClient={isQuotation ? onlineOrder.cotizacion_cliente : onlineOrder.pedido_cliente}
                  isQuotation={isQuotation}
                />
              }
            </div>
          </div>
          :
          <div style={{ width: '100%', textAlign: 'center'}}>
            <Spin />
          </div>
        }

      </div>
    );
  }
}

const mapStateToProps = ({ catalog }) => {
  const { onlineOrdersToMerge, onlineQuotationsToMerge} = catalog
  return { onlineOrdersToMerge, onlineQuotationsToMerge };
};

export default connect(mapStateToProps, {
  getOnlineOrderToMerge,
  getOnlineQuotationToMerge
})(withTranslation()(CatalogOrderQuotationMergeDetail));

